import React, { useState, useRef } from 'react';
import { Draggable, state } from '../../../../libraries/react-page-maker';
import { ClickAwayListener, Box, TextField, InputAdornment, IconButton, Tooltip } from '@material-ui/core';
import MoreActionButton from '../../components/more-actions/more-action-tool';
import ContactsIcon from '@material-ui/icons/Contacts';
import { getComputedStyle, getStyle } from '../../utils/style';
import { addressBook as property } from './property';
import AddressBookPreview from './preview/AddressBook';
import useStyle from '../../style';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
});

const DAddressBook = (props) => {
  const { id, uniquekey, showBasicContent, showPreview, dropzoneID, idocument, parentID, onSelect, type, iconComponent, setState, propertyValue, selectedComponent } = props;
  const elementLabel = props.label;
  const [label, setLable] = useState(props.label);
  const [isEdit, setEdit] = useState(false);
  const [defaultPropertyValue, setDefaultPropertyValue] = useState(null);
  const [isHover, setHover] = useState(false);
  const classes = useStyle();
  const classes1 = useStyles();

  if (showBasicContent) {
    let data = { ...props };
    data.propertyValue = defaultPropertyValue;
    return (
      <Draggable {...data}>
        {iconComponent}
        <AddressBookPreview setDefaultPropertyValue={setDefaultPropertyValue} />
      </Draggable>
    );
  }

  const onChange = async (value) => {
    await setLable(value);
    await setEdit(true);
  };
  const updatelabel = async () => {
    if (isEdit) {
      if (label !== elementLabel) {
        await setState({ addAction: true });
        await setEdit(false);
        state.updateElement(id, dropzoneID, parentID, { label: label },()=>{
          onSelect({ id, dropzoneID, uniquekey, propertyValue, parentID, type, label: label, property }, false);
        });
      }
    }
  };

  const onClick = (e) => {
    onSelect(
      {
        id,
        dropzoneID,
        parentID,
        uniquekey,
        type,
        label: props.label,
        property,
        propertyValue,
      },
      false,
      e
    );
  };

  const _additionalAttributes = () => {

    let attr = {style: { paddingTop: elementLabel ? 27 : 10 }};
    const textAlign = propertyValue?.text?.textAlign
    if (textAlign) {
      attr.style = { ...attr.style, textAlign }
    }
    return attr;
  };


  const handleActions = (e) => {
    e.stopPropagation();
    let position = { x: e.clientX, y: e.clientY };
    onSelect(
      {
        id,
        dropzoneID,
        parentID,
        uniquekey,
        type,
        label: props.label,
        property,
        isActions: true,
        position,
        propertyValue,
      },
      false,
      e
    );
  };

  if (showPreview) {
    return (
        <TextField
          fullWidth
          className={`${classes.paddingZero} ${propertyValue.component.classes??''}`}
          style={{ ...getStyle(propertyValue, ['layout']), padding: 0 }}
          label={<label style={getStyle(propertyValue, ['text'])}>{elementLabel}</label>}
          placeholder={propertyValue ? propertyValue.component.placeholder : 'Placeholder'}
          margin="normal"
          InputLabelProps={{
            shrink: true,
            style: { pointerEvents: 'all' },
          }}
          disabled={true}
          variant="filled"
          inputProps={_additionalAttributes()}
          InputProps={{
            style: {...getStyle(propertyValue, ['text', 'layout', 'style']) },
            className: `${classes.marginZero} ${classes.underline} ${classes.textBorder}`,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <ContactsIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
    );
  }

  return (
    <Draggable {...props} dataid={`${id}_parent`} onClick={onClick}>
      {(data1) => (
        <Tooltip  arrow
          title = {propertyValue?.tooltip?.title || ""}
          placement = {propertyValue?.tooltip?.position || ""}
          PopperProps={{ disablePortal: true }}
        >
          <TextField
            fullWidth
            onMouseOut={(e) => {
              e.stopPropagation();
              setHover(false);
            }}
            onMouseOver={(e) => {
              e.stopPropagation();
              setHover(true);
            }}
            className={`${type} ${data1.className} draggable-component ${isHover && 'draggable-hover'} ${classes.paddingZero} ${selectedComponent?.id === id && 'highlight-component'} ${propertyValue.component.classes??''}`}
            style={{ ...getStyle(propertyValue, ['layout']), padding: 0 }}
            label={
              <label
                id={propertyValue.component.id} dataid={`${id}_parent`}
                style={getStyle(propertyValue, ['text'])}
                onDoubleClick={async (e) => {
                  e.persist();
                  const event = e;
                  await setEdit(true);
                  event.target.focus();
                }}
                contenteditable={isEdit ? 'true' : 'false'}
                onBlur={(e) => updatelabel()}
                onInput={(e) => onChange(e.currentTarget.innerText)}
              >
                {elementLabel}
              </label>
            }
            compid={propertyValue.component.id}
            placeholder={propertyValue ? propertyValue.component.placeholder : 'Placeholder'}
            margin="normal"
            InputLabelProps={{
              shrink: true,
              style: { pointerEvents: 'all' },
            }}
            disabled={true}
            variant="filled"
            inputProps={_additionalAttributes()}
            InputProps={{
              style: {...getStyle(propertyValue, ['text', 'layout', 'style']) },
              className: `${classes.marginZero} ${classes.underline} ${classes.textBorder}`,
              endAdornment: (
                <>
                <InputAdornment position="end">
                  <IconButton>
                    <ContactsIcon />
                  </IconButton>
                </InputAdornment>
                {selectedComponent?.id === id && (
                    <MoreActionButton
                      handleActions={handleActions}
                      type={'Address Book'}
                      showParentSelection={true}
                      idocument={idocument}
                      anchorElement={data1.anchorelement}
                      parentID={dropzoneID}
                      selectParent={(e) => {
                        e.stopPropagation();
                        // setShowMoreActions(false)
                      }}
                    />
                  )}
                </>
              ),
            }}
          />
        </Tooltip>
      )}
    </Draggable>
  );
};

export default DAddressBook;
